export interface IRecordsReviewedRequest {
  caseLineItemId: number
  recordsReviewedDate: Date
}

export class RecordsReviewedRequest implements IRecordsReviewedRequest {
  public caseLineItemId: number
  public recordsReviewedDate: Date
}
